module.exports = __webpack_public_path__ + "img/thumbnail_GiantAnteater_f_normal.25783582.png";